import React from 'react';
import './QUestionnaireQuestionsNavigation.scss';
import {QuestionnaireSessionReactContext} from "../../../contexts/QuestionnaireContext/QuestionnaireSessionContext";
import {useContextSelector} from "use-context-selector";
import {get} from "lodash";
import { SignDocTypes } from "../../SignDoc/SignDocLib";

export const QuestionnaireQuestionsNavigation = () => {
    const currentQuestionIndex = useContextSelector(QuestionnaireSessionReactContext, context => context.currentQuestionIndex);
    const sessionQuestions = useContextSelector(QuestionnaireSessionReactContext, context => context.sessionQuestions);
    const questionnaireSession = useContextSelector(QuestionnaireSessionReactContext, context => context.questionnaireSession);
    const navigateToQuestion = useContextSelector(QuestionnaireSessionReactContext, context => context.navigateToQuestion);
    
    // Detect if this is a survey
    const questionnaireType = get(questionnaireSession, 'type');

    const isQuestionAnswered = ({questionIndex}) => {
        const question = sessionQuestions[questionIndex];
        if (!question) return false;
        
        if (questionnaireType === SignDocTypes.SURVEY) {
            // For surveys, check different answer types
            const userAnswers = get(question, 'userAnswers', []);
            const hasTextResponse = get(question, 'textResponse');
            const hasRatingValue = get(question, 'ratingValue');
            
            return userAnswers.length > 0 || hasTextResponse || hasRatingValue;
        } else if (questionnaireType === SignDocTypes.EXAM) {
            // For exams, just check userAnswers
            return question.userAnswers?.length > 0 || question.textResponse;
        }
    };

    return (
        <div className="questionnaireNavigation" data-testid="questionnaire-navigation">
            <div className="questionnaireNavigationItems" data-testid="navigation-items">
                {sessionQuestions.map((question, index) => (
                    <div
                        key={question.id || index}
                        className={`questionnaireNavigationItem 
                            ${currentQuestionIndex === index ? 'active' : ''}
                            ${isQuestionAnswered({questionIndex: index}) ? 'answered' : ''}`}
                        onClick={() => navigateToQuestion({nextQuestionIndex: index})}
                        data-testid={`navigation-item-${index}`}
                    >
                        {index + 1}
                    </div>
                ))}
            </div>
        </div>
    );
};